import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  useTranslation,
  betStore,
  maskName,
  convertAmount,
  userInfoStore,
  BetStatus,
  toFixed,
  exchangeAmountByRate,
} from '@pascal/pascal-core';
import { globalTranslationKeys } from '../../enums/translationKeys';

const LiveBets = observer(() => {
  const t = useTranslation();
  const { liveBets } = betStore;
  const { userId: currentUserId } = userInfoStore;
  const { User, Bet, Odd, Payout, FreeBet, Me } = globalTranslationKeys;

  useEffect(() => {
    return () => {
      betStore.setLiveBets(betStore.liveBets.filter((item) => !item?.winAmount));
    };
  }, []);

  return (
    <div className='winning-table-wrapper'>
      <input type='checkbox' id='winning-table-trigger' />
      <div className='winning-table'>
        <div className='winning-table-header-container'>
          <span className='winning-table-header-txt'>{t(User)}</span>
          <span className='winning-table-header-txt'>{t(Bet)}</span>
          <span className='winning-table-header-txt'>{t(Odd)}</span>
          <span className='winning-table-header-txt'>{t(Payout)}</span>
        </div>
        <div className='winning-table-body-wrapper'>
          <div className='winning-table-body'>
            {liveBets.map((bet) => {
              const { userId, odd, id, freeBetId, status, isRoundFinish } = bet;
              return (
                <div
                  className={`winning-table-body-row ${bet.winAmount ? 'active' : ''} ${
                    isRoundFinish || status === BetStatus.Lose || status === BetStatus.Win
                      ? 'remove'
                      : 'show'
                  }`}
                  key={id}
                >
                  <div className='winning-table-row-item'>
                    <div className='winning-table-cell'>
                      {+userId === +currentUserId ? t(Me) : maskName(userId)}
                    </div>
                    <div className='winning-table-cell'>
                      {freeBetId
                        ? t(FreeBet)
                        : convertAmount(
                            +userId === +currentUserId
                              ? bet.amount
                              : toFixed(exchangeAmountByRate(bet).amount)
                          )}
                    </div>
                    <div className='winning-table-cell'>x{odd}</div>
                    <div className='winning-table-cell'>
                      {bet.status !== BetStatus.Pending
                        ? convertAmount(
                            +userId === +currentUserId
                              ? bet.winAmount
                              : toFixed(exchangeAmountByRate(bet).winAmount)
                          )
                        : '-'}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <label
        htmlFor='winning-table-trigger'
        className='winning-table-toggle'
        data-more-label={t(globalTranslationKeys.ShowMore)}
        data-less-label={t(globalTranslationKeys.ShowLess)}
      >
        <span className='winning-table-toggle-arrow icon-chevron' />
      </label>
    </div>
  );
});

export default LiveBets;
